/**
 * Utility functions for determining academic periods based on current date
 */

/**
 * Determines the current academic period based on the current date
 * @returns The current period: 'fall', 'winter', 'spring', or 'summer'
 */
export function getCurrentPeriod(): string {
  const now = new Date();
  const month = now.getMonth() + 1; // getMonth() returns 0-11, so add 1
  
  // Academic year periods (approximate)
  if (month >= 8 && month <= 11) {
    return 'fall';
  } else if (month === 12 || month === 1) {
    return 'winter';
  } else if (month >= 2 && month <= 5) {
    return 'spring';
  } else {
    return 'summer';
  }
}

/**
 * Gets the current year
 * @returns The current year as a string
 */
export function getCurrentYear(): string {
  return new Date().getFullYear().toString();
}
